import React from "react";
import { CardHeader, SkeletonBox, SkeletonCard } from "../styles";

export const TemplatePreviewSkeleton = () => {
  return (
    <SkeletonCard>
      <CardHeader>
        <SkeletonBox $width="60%" $mb="12px" />
        <SkeletonBox $width="20%" $radius="20px" />
      </CardHeader>

      <SkeletonBox $width="40%" $mb="16px" height="14px" />

      <SkeletonBox $height="60px" />
    </SkeletonCard>
  );
};
